import { ColumnDef } from '@tanstack/react-table';
import { ActiveSourcingChannelDetails } from 'api-clients/monolith';

import { useDataTable } from '@/hooks/use-data-table';

import { Cards } from './cards';

interface CampaignsProps {
  campaigns: ActiveSourcingChannelDetails[];
  columns: ColumnDef<ActiveSourcingChannelDetails>[];
  /** The opening's IANA zone, when metrics count its local days. */
  timeZone?: string;
}

export function Campaigns({ campaigns, columns, timeZone }: CampaignsProps) {
  const { table } = useDataTable<ActiveSourcingChannelDetails>({
    columns,
    data: campaigns,
    rowCount: campaigns.length,
  });

  return (
    <div className="w-full">
      <div className="overflow-x-auto">
        <div className="min-w-[975px]">
          <div className="space-y-4 pb-2">
            <Cards table={table} timeZone={timeZone} />
          </div>
        </div>
      </div>
    </div>
  );
}

Campaigns.Skeleton = function CampaignsSkeleton() {
  return (
    <div className="w-full">
      <div className="overflow-x-auto">
        <div className="min-w-[975px]">
          <div className="space-y-4 pb-2">
            <Cards.Skeleton />
          </div>
        </div>
      </div>
    </div>
  );
};
